(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var cartEl     = document.querySelector('[data-cart]');
    if (!cartEl) return;

    var moneyFormat = cartEl.getAttribute('data-money-format') || '';
    var currency    = cartEl.getAttribute('data-currency') || '';
    var cartTotalEl = document.querySelector('[data-cart-total]');
    var cartCountEl = document.querySelector('[data-cart-count]');
    var cartFooter  = document.querySelector('[data-cart-footer]');
    var timers      = {};

    var ob = String.fromCharCode(123, 123);
    var cb = String.fromCharCode(125, 125);
    var KEY_AMOUNT       = ob + 'amount'                                  + cb;
    var KEY_NO_DEC       = ob + 'amount_no_decimals'                      + cb;
    var KEY_COMMA        = ob + 'amount_with_comma_separator'             + cb;
    var KEY_NO_DEC_COMMA = ob + 'amount_no_decimals_with_comma_separator' + cb;

    function formatMoney(cents) {
      var isWhole          = cents % 100 === 0;
      var amount           = isWhole ? String(cents / 100) : (cents / 100).toFixed(2);
      var amountNoDecimals = String(Math.round(cents / 100));
      var withComma        = amount.replace('.', ',');
      var noDecComma       = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = (moneyFormat || amount)
        .replace(KEY_AMOUNT,       amount)
        .replace(KEY_NO_DEC,       amountNoDecimals)
        .replace(KEY_COMMA,        withComma)
        .replace(KEY_NO_DEC_COMMA, noDecComma);
      return currency ? formatted + ' ' + currency : formatted;
    }

    // Write server values back onto the DOM row (keeps data-key fresh)
    function syncItem(itemEl, serverItem) {
      itemEl.setAttribute('data-key', serverItem.key);
      var input   = itemEl.querySelector('[data-qty]');
      var priceEl = itemEl.querySelector('[data-line-price]');
      if (input)   input.value         = serverItem.quantity;
      if (priceEl) priceEl.textContent = formatMoney(serverItem.original_line_price);
    }

    function syncTotals(cart) {
      if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);
      if (cartCountEl) cartCountEl.textContent = cart.item_count;

      var discountEls = document.querySelectorAll('[data-discount-title]');
      if (!discountEls.length) return;

      var apps = cart.cart_level_discount_applications || [];
      for (var d = 0; d < discountEls.length; d++) {
        var title  = discountEls[d].getAttribute('data-discount-title');
        var amount = cart.total_discount || 0; // reliable fallback
        for (var a = 0; a < apps.length; a++) {
          if (apps[a].title === title && apps[a].total_allocated_amount != null) {
            amount = apps[a].total_allocated_amount;
            break;
          }
        }
        discountEls[d].textContent = '−' + formatMoney(amount);
      }
    }

    // Find a cart item by variant ID (stable even if Shopify changes the key)
    function findByVariant(items, variantId) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].variant_id === variantId) return items[i];
      }
      return null;
    }

    function applyUpdate(itemEl, qty) {
      var key       = itemEl.getAttribute('data-key');
      var variantId = parseInt(itemEl.getAttribute('data-variant-id'), 10);

      itemEl.style.opacity = '0.4';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          itemEl.style.opacity = '';

          if (cart.status) {
            // Rejected (e.g. exceeds stock) — fetch real cart and revert
            return fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (real) {
                var match = findByVariant(real.items || [], variantId);
                if (match) syncItem(itemEl, match);
                syncTotals(real);
              });
          }

          if (qty === 0) {
            itemEl.remove();
            if (!cartEl.querySelector('[data-key]')) {
              var p = document.createElement('p');
              p.textContent = cartEl.getAttribute('data-empty-text') || '';
              cartEl.insertAdjacentElement('afterend', p);
              cartEl.remove();
              if (cartFooter) cartFooter.remove();
            }
          } else {
            var match = findByVariant(cart.items || [], variantId);
            if (match) syncItem(itemEl, match); // refreshes data-key for next update
          }

          syncTotals(cart);
        })
        .catch(function () {
          itemEl.style.opacity = '';
        });
    }

    // Timer reads qty from the element when it fires, not from the click closure
    function scheduleUpdate(itemEl) {
      var key = itemEl.getAttribute('data-key');
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () {
        var qty = Math.max(0, parseInt(itemEl.querySelector('[data-qty]').value, 10) || 0);
        applyUpdate(itemEl, qty);
      }, 400);
    }

    cartEl.addEventListener('click', function (e) {
      var itemEl = e.target.closest('[data-key]');
      if (!itemEl) return;
      var input = itemEl.querySelector('[data-qty]');
      var qty   = parseInt(input.value, 10) || 0;

      if (e.target.closest('[data-decrease]')) {
        e.preventDefault();
        input.value = Math.max(0, qty - 1);
        scheduleUpdate(itemEl);
      } else if (e.target.closest('[data-increase]')) {
        e.preventDefault();
        input.value = qty + 1;
        scheduleUpdate(itemEl);
      }
    });

    cartEl.addEventListener('input', function (e) {
      if (!e.target.matches('[data-qty]')) return;
      var itemEl = e.target.closest('[data-key]');
      if (!itemEl) return;
      e.target.value = Math.max(0, parseInt(e.target.value, 10) || 0);
      scheduleUpdate(itemEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function initInfiniteScroll() {
      var list = document.querySelector('[data-products-list]');
      var trigger = document.querySelector('[data-infinite-scroll]');
      if (!list || !trigger) return;

      var loading = false;

      function getLink() {
        return trigger.querySelector('[data-load-more]');
      }

      function loadMore() {
        var link = getLink();
        if (!link || loading) return;
        loading = true;
        var url = link.getAttribute('href');
        link.textContent = link.getAttribute('data-loading') || 'Loading…';

        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('[data-products-list] > li');

            for (var i = 0; i < newItems.length; i++) {
              list.appendChild(newItems[i]);
            }

            var nextLink = doc.querySelector('[data-load-more]');
            if (nextLink) {
              link.setAttribute('href', nextLink.getAttribute('href'));
              link.textContent = link.getAttribute('data-label') || 'Load more';
              loading = false;
            } else {
              observer.disconnect();
              trigger.remove();
            }
          })
          .catch(function () {
            // Leave the link so the customer can retry by clicking it.
            link.textContent = link.getAttribute('data-label') || 'Load more';
            loading = false;
          });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) loadMore();
          }
        },
        { rootMargin: '400px 0px' }
      );

      observer.observe(trigger);

      // Keep the link clickable; clicking loads in place instead of navigating.
      trigger.addEventListener('click', function (event) {
        var link = getLink();
        if (link && (event.target === link || link.contains(event.target))) {
          event.preventDefault();
          loadMore();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initInfiniteScroll);
    } else {
      initInfiniteScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var btn   = document.querySelector('[data-open-policies]');
    var modal = document.querySelector('[data-policies-modal]');
    if (!btn || !modal) return;

    var loadingLabel = modal.getAttribute('data-loading') || 'Loading…';
    var loaded = false;

    // Open links inside the modal in a new tab so the modal stays open. Runs
    // again after each injection, since the policy bodies arrive later.
    function externalizeLinks(root) {
      root.querySelectorAll('a').forEach(function (a) {
        if (!a.target) a.target = '_blank';
        a.rel = 'noopener';
      });
    }

    /**
     * Pull each policy's body out of its own /policies/* page. The placeholder
     * link is left in place on failure, so the policy stays reachable.
     * Uses the same fetch + DOMParser approach as the collection infinite scroll.
     */
    function loadPolicies() {
      if (loaded) return;
      loaded = true;

      modal.querySelectorAll('[data-policy]').forEach(function (policy) {
        var url = policy.getAttribute('data-policy-url');
        var target = policy.querySelector('[data-policy-body]');
        if (!url || !target) return;

        var fallback = target.innerHTML;
        target.textContent = loadingLabel;

        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var body = doc.querySelector('.shopify-policy__body');
            if (!body) throw new Error('No policy body');
            target.innerHTML = body.innerHTML;
            externalizeLinks(target);
          })
          .catch(function () {
            target.innerHTML = fallback;
            externalizeLinks(target);
          });
      });
    }

    btn.addEventListener('click', function () {
      loadPolicies();
      modal.showModal();
    });

    // Warm the content on intent, so the modal is usually populated on open.
    btn.addEventListener('mouseenter', loadPolicies);
    btn.addEventListener('focus', loadPolicies);

    externalizeLinks(modal);

    modal.querySelector('[data-close-policies]').addEventListener('click', function () {
      modal.close();
    });

    // Close on backdrop click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getDate(li) {
      var card = li.querySelector('[data-date]');
      return card ? (card.getAttribute('data-date') || '') : '';
    }

    function getAvailable(li) {
      var card = li.querySelector('[data-available]');
      return card ? card.getAttribute('data-available') === 'true' : true;
    }

    /**
     * Sort products: in-stock first, then out-of-stock.
     * Within each group, newest date first.
     * ISO date strings (YYYY-MM-DD) compare correctly as plain strings.
     * Uses a DocumentFragment so only one reflow is triggered.
     */
    function sortByDate(list) {
      var items = Array.from(list.children);
      items.sort(function (a, b) {
        var aAvail = getAvailable(a);
        var bAvail = getAvailable(b);
        if (aAvail !== bAvail) return aAvail ? -1 : 1;
        var da = getDate(a);
        var db = getDate(b);
        if (!da && !db) return 0;
        if (!da) return 1;
        if (!db) return -1;
        if (db > da) return 1;
        if (db < da) return -1;
        return 0;
      });
      var frag = document.createDocumentFragment();
      items.forEach(function (item) {
        frag.appendChild(item);
      });
      list.appendChild(frag);
    }

    /**
     * Start the opening row downloading as soon as the real order is known.
     * The cards are rendered lazily because the server cannot predict where
     * sorting will place them; flipping loading to eager here kicks off the
     * fetch immediately, and the card that becomes the Largest Contentful
     * Paint element is almost always in this row.
     */
    function prioritiseFirstRow(list, count) {
      var items = list.children;
      for (var i = 0; i < items.length && i < count; i++) {
        var img = items[i].querySelector('img');
        if (!img || img.getAttribute('loading') === 'eager') continue;
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      }
    }

    function initInfiniteScroll() {
      var list = document.querySelector('[data-products-list]');
      var trigger = document.querySelector('[data-infinite-scroll]');
      if (!list) return;

      // Sort the server-rendered first batch immediately.
      sortByDate(list);

      // Widest grid is four across, so four cards covers the first row.
      prioritiseFirstRow(list, 4);

      if (!trigger) return;

      var loading = false;

      function getLink() {
        return trigger.querySelector('[data-load-more]');
      }

      function loadMore() {
        var link = getLink();
        if (!link || loading) return;
        loading = true;
        var url = link.getAttribute('href');
        link.textContent = link.getAttribute('data-loading') || 'Loading…';

        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('[data-products-list] > li');

            for (var i = 0; i < newItems.length; i++) {
              list.appendChild(newItems[i]);
            }

            // Re-sort all items (existing + newly appended) together.
            sortByDate(list);

            var nextLink = doc.querySelector('[data-load-more]');
            if (nextLink) {
              link.setAttribute('href', nextLink.getAttribute('href'));
              link.textContent = link.getAttribute('data-label') || 'Load more';
              loading = false;
            } else {
              observer.disconnect();
              trigger.remove();
            }
          })
          .catch(function () {
            // Leave the link visible so the customer can retry by clicking it.
            link.textContent = link.getAttribute('data-label') || 'Load more';
            loading = false;
          });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) loadMore();
          }
        },
        { rootMargin: '400px 0px' }
      );

      observer.observe(trigger);

      // Also allow the customer to trigger loading by clicking the link.
      trigger.addEventListener('click', function (event) {
        var link = getLink();
        if (link && (event.target === link || link.contains(event.target))) {
          event.preventDefault();
          loadMore();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initInfiniteScroll);
    } else {
      initInfiniteScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var form     = document.querySelector('.product__form');
    var btn      = form && form.querySelector('[data-add-to-cart-btn]');
    var select   = form && form.querySelector('[data-variant-select]');
    var qtyInput = form && form.querySelector('[data-qty-input]');

    /*
     * The add-to-cart button is only rendered for a purchasable variant, so a
     * sold-out product has no button — and returning here used to kill the
     * image gallery further down with it, leaving the thumbnails inert on
     * every sold-out product. Only the buying controls depend on the button
     * now; the gallery is set up unconditionally at the end of this file.
     */
    var canBuy = !!(form && btn);

    var dataEl = document.getElementById('product-data-json');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);

    var variants       = data.variants;
    var moneyFormat    = data.moneyFormat || '';
    var currency       = data.currency    || '';
    var label          = data.addToCartLabel  || 'Add to cart';
    var inCartLabel    = data.inCartLabel     || 'already in cart';
    var addAnotherLabel = data.addAnotherLabel || 'Add another to cart';
    var cartItems      = data.cartItems       || [];

    var ob = String.fromCharCode(123, 123);
    var cb = String.fromCharCode(125, 125);
    var KEY_AMOUNT       = ob + 'amount'                                  + cb;
    var KEY_NO_DEC       = ob + 'amount_no_decimals'                      + cb;
    var KEY_COMMA        = ob + 'amount_with_comma_separator'             + cb;
    var KEY_NO_DEC_COMMA = ob + 'amount_no_decimals_with_comma_separator' + cb;

    function formatMoney(cents) {
      var isWhole          = cents % 100 === 0;
      var amount           = isWhole ? String(cents / 100) : (cents / 100).toFixed(2);
      var amountNoDecimals = String(Math.round(cents / 100));
      var withComma        = amount.replace('.', ',');
      var noDecComma       = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = (moneyFormat || amount)
        .replace(KEY_AMOUNT,       amount)
        .replace(KEY_NO_DEC,       amountNoDecimals)
        .replace(KEY_COMMA,        withComma)
        .replace(KEY_NO_DEC_COMMA, noDecComma);
      return currency ? formatted + ' ' + currency : formatted;
    }

    function cartQtyForVariant(variantId) {
      var item = cartItems.filter(function (i) { return i.variant_id === variantId; })[0];
      return item ? item.quantity : 0;
    }

    function updateBtn() {
      if (!canBuy) return;
      var variantId = select ? parseInt(select.value, 10) : null;
      var variant = variantId
        ? variants.filter(function (v) { return v.id === variantId; })[0]
        : variants[0];
      if (!variant) return;

      var qty    = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var price  = variant.price * qty;
      var inCart = cartQtyForVariant(variant.id);
      if (inCart > 0) {
        btn.innerHTML = inCart + ' ' + inCartLabel + '<br>' + addAnotherLabel + ' — ' + formatMoney(price);
      } else {
        btn.textContent = label + ' — ' + formatMoney(price);
      }
    }

    /* ── Gallery ── */
    var mainImg = document.querySelector('.product__gallery-main-img');
    var thumbs  = Array.from(document.querySelectorAll('[data-thumb]'));

    function activateThumb(thumb) {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.removeAttribute('aria-current');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

      if (mainImg) {
        var src    = thumb.getAttribute('data-full-src');
        var srcset = thumb.getAttribute('data-full-srcset') || '';
        var alt    = thumb.getAttribute('data-full-alt');
        mainImg.classList.add('is-loading');

        // Preload through the same srcset/sizes the main image uses, so the
        // browser picks (and then reuses from cache) the right candidate.
        var next = new Image();
        next.onload = function () {
          mainImg.srcset = srcset;
          mainImg.src = src;
          mainImg.alt = alt;
          mainImg.classList.remove('is-loading');
        };
        next.sizes = mainImg.sizes || '';
        next.srcset = srcset;
        next.src = src;
      }
    }

    function updateVariantForThumb(thumb) {
      if (!select) return;
      var imageId = thumb.getAttribute('data-image-id');
      var match = variants.filter(function (v) {
        return v.featured_image && String(v.featured_image.id) === imageId;
      })[0];
      if (match && String(select.value) !== String(match.id)) {
        select.value = match.id;
        updateBtn();
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(thumb);
        updateVariantForThumb(thumb);
      });
    });

    function updateGallery() {
      if (!mainImg || thumbs.length === 0) return;
      var variantId = select ? parseInt(select.value, 10) : null;
      var variant = variantId
        ? variants.filter(function (v) { return v.id === variantId; })[0]
        : null;
      if (!variant || !variant.featured_image) return;

      var imageId = String(variant.featured_image.id);
      var target  = thumbs.filter(function (t) {
        return t.getAttribute('data-image-id') === imageId;
      })[0];
      if (target) activateThumb(target);
    }

    if (select) {
      select.addEventListener('change', function () {
        updateBtn();
        updateGallery();
      });
    }

    if (qtyInput && qtyInput.type !== 'hidden') {
      qtyInput.addEventListener('input',  updateBtn);
      qtyInput.addEventListener('change', updateBtn);
    }

    updateBtn();

    if (canBuy) {
      form.addEventListener('submit', function () {
        setTimeout(function () {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cartItems = cart.items;
              updateBtn();
            });
        }, 800);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
